function onScrollCustomizeTopDo() {
  let scrollingTop = window.pageYOffset || document.documentElement.scrollTop;
  let sectionHeight = document.querySelector(".customize-top").offsetHeight;
  let backgroundChangeElements = document.querySelectorAll(".stages, .know, .calculate");

  if (scrollingTop > sectionHeight) {
    backgroundChangeElements.forEach(element => element.classList.remove("_background-change"));
  } else {
    backgroundChangeElements.forEach(element => element.classList.add("_background-change"));
  }
}

onScrollCustomizeTopDo();

window.addEventListener("scroll", onScrollCustomizeTopDo);
window.addEventListener("resize", onScrollCustomizeTopDo);

const titles = document.querySelectorAll(".stages__title *");
titles.forEach(title => {
  let firstSpace = title.innerText.indexOf(" ");
  if (firstSpace !== -1) {
    let firstWord = title.innerText.substring(0, firstSpace);
    let restOfString = title.innerText.substring(firstSpace + 1);
    if (document.querySelector("html").getAttribute("lang") === "en") {
      title.innerHTML = firstWord + "<br>" + restOfString;
    }
  }
});